'use strict';
// https://github.com/tc39/proposal-math-sum
require('../modules/esnext.math.sum-precise');
